<template>
  <BaseYoutubeVideo :url="url" />
</template>
<script>
import BaseYoutubeVideo from "../../base/base-youtube-video";
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  },
  components: { BaseYoutubeVideo },
};
</script>
